;(() => {
  // ====== GLOBAL STATE ======
  window.__KB_MENU_STATE__ = window.__KB_MENU_STATE__ || {};
  const ST = window.__KB_MENU_STATE__;
  ST.boots = (ST.boots || 0) + 1;
  ST.lastBoot = new Date().toISOString();

  window.__KB_MENU_READY__ = false;

  // modalità: "top" = stai navigando top-level, "submenu" = sei dentro un dropdown
  ST.mode = ST.mode || "top";
  ST.activeDropdown = ST.activeDropdown || null;
  ST.activeItem = ST.activeItem || null;

  // ====== DESKTOP ONLY ======
  const DESKTOP_MQ = "(min-width: 990px) and (hover: hover) and (pointer: fine)";
  const isDesktop = () => window.matchMedia(DESKTOP_MQ).matches;

  // ====== SELECTORS ======
  const ROOT_SEL = '[data-header-desktop] .header__menu';
  const TOPLINK_SEL = 'a.navlink--toplevel[data-top-link]';
  const ITEM_SEL = '.menu__item[aria-controls]';
  const DROPDOWN_SEL = '.header__dropdown[data-hover-disclosure]';
  const DATA_ORIG = "data-kb-orig-tabindex";

  const esc = (s) =>
    (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/[^a-zA-Z0-9_-]/g, "\\$&");

  // ====== TABINDEX LOCK/UNLOCK ======
  function rememberOriginalTabindex(a) {
    if (a.hasAttribute(DATA_ORIG)) return;
    const cur = a.getAttribute("tabindex");
    a.setAttribute(DATA_ORIG, cur == null ? "" : cur); // "" = non c'era tabindex
  }

  function lockAllDropdownLinks(root) {
    root.querySelectorAll(`${DROPDOWN_SEL} a[href]`).forEach((a) => {
      rememberOriginalTabindex(a);
      a.setAttribute("tabindex", "-1"); // TAB non entra mai nei dropdown
    });
  }

  function unlockDropdownLinks(dropdown) {
    dropdown.querySelectorAll("a[href]").forEach((a) => {
      if (!a.hasAttribute(DATA_ORIG)) return;
      const orig = a.getAttribute(DATA_ORIG);
      if (orig === "") a.removeAttribute("tabindex");
      else a.setAttribute("tabindex", orig);
    });
  }

  function applyTabLock(root) {
    // default: tutto bloccato
    lockAllDropdownLinks(root);

    // se sei entrato nel submenu via ArrowDown, sblocca SOLO quel dropdown
    if (ST.mode === "submenu" && ST.activeDropdown && root.contains(ST.activeDropdown)) {
      unlockDropdownLinks(ST.activeDropdown);
    }
  }

  // ====== HELPERS ======
  function setExpanded(item, open) {
    item.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function getObjFromTopLink(topLink, root) {
    const item = topLink.closest(ITEM_SEL);
    if (!item) return null;

    const id = item.getAttribute("aria-controls");
    let dropdown = null;

    if (id) dropdown = document.getElementById(id) || item.querySelector(`#${esc(id)}`);
    if (!dropdown) dropdown = item.querySelector(DROPDOWN_SEL);
    if (!dropdown) return null;

    return { root, item, topLink, dropdown };
  }

  function firstRealLink(dropdown) {
    const links = [...dropdown.querySelectorAll("a[href]")];
    return (
      links.find((a) => {
        const h = (a.getAttribute("href") || "").trim();
        return h && h !== "#" && h !== "#/" && !h.toLowerCase().startsWith("javascript:");
      }) ||
      links[0] ||
      null
    );
  }

  function nudgeOpen(item) {
    // non rompe se il tema lo ignora
    item.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true, cancelable: true }));
    item.dispatchEvent(new Event("focusin", { bubbles: true }));
  }

  // ENTER: apre/chiude visivamente ma RESTA su top-level (non entra)
  function toggleOpenStayTop(obj) {
    ST.mode = "top";
    ST.activeDropdown = null;
    ST.activeItem = null;

    const isOpen = obj.item.getAttribute("aria-expanded") === "true";
    setExpanded(obj.item, !isOpen);
    if (!isOpen) nudgeOpen(obj.item);

    applyTabLock(obj.root);
  }

  // ArrowDown: entra davvero nel dropdown (sblocca tabindex + focus primo link)
  function enterSubmenu(obj) {
    setExpanded(obj.item, true);
    nudgeOpen(obj.item);

    ST.mode = "submenu";
    ST.activeDropdown = obj.dropdown;
    ST.activeItem = obj.item;

    applyTabLock(obj.root);

    const first = firstRealLink(obj.dropdown);
    if (first) first.focus({ preventScroll: true });
  }

  function exitSubmenu(root) {
    ST.mode = "top";
    ST.activeDropdown = null;
    ST.activeItem = null;
    applyTabLock(root);
  }

  // ====== ATTACH ======
  function attach() {
    const root = document.querySelector(ROOT_SEL);
    if (!root) return false;

    applyTabLock(root);

    // CLICK capture: blocca sempre /# (hash), ma NON far entrare nel submenu con TAB
    root.addEventListener(
      "click",
      (e) => {
        if (!isDesktop()) return;

        const a = e.target.closest(TOPLINK_SEL);
        if (!a) return;

        const obj = getObjFromTopLink(a, root);
        if (!obj) return;

        const href = (a.getAttribute("href") || "").trim();
        const isHash = href === "#" || href === "#/" || href.startsWith("#");
        if (!isHash) return;

        // niente /# in URL
        e.preventDefault();

        // click "virtuale" da tastiera (ENTER/SPACE) => toggle open ma NON entra
        if (e.detail === 0) {
          e.stopPropagation();
          try { e.stopImmediatePropagation(); } catch (_) {}
          toggleOpenStayTop(obj);
        }
        // mouse click: lasciamo al tema il comportamento (noi abbiamo solo evitato /#)
      },
      true
    );

    // KEYDOWN capture
    root.addEventListener(
      "keydown",
      (e) => {
        if (!isDesktop()) return;

        // ── 1. FOCUS SU TOP-LEVEL LINK ──────────────────────────────────────
        const topLink = e.target.closest(TOPLINK_SEL);
        if (topLink) {
          const obj = getObjFromTopLink(topLink, root);
          if (!obj) return;

          // TAB: deve SOLO andare alla voce successiva => non preventDefault
          if (e.key === "Tab") {
            exitSubmenu(root); // garantisce che TAB non entri mai nel dropdown
            return;
          }

          // ENTER / SPACE: apre/chiude ma resta sul top-level (NON entra)
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            try { e.stopImmediatePropagation(); } catch (_) {}
            toggleOpenStayTop(obj);
            return;
          }

          // FRECCIA GIÙ: entra nel submenu
          if (e.key === "ArrowDown") {
            e.preventDefault();
            e.stopPropagation();
            try { e.stopImmediatePropagation(); } catch (_) {}
            enterSubmenu(obj);
            return;
          }

          return;
        }

        // ── 2. FOCUS DENTRO UN DROPDOWN ─────────────────────────────────────
        if (ST.mode === "submenu" && ST.activeDropdown) {
          const isInsideDropdown = e.target.closest(DROPDOWN_SEL);
          if (isInsideDropdown) {

            // FRECCE SU/GIÙ: naviga tra i link interni del dropdown
            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
              e.preventDefault();
              e.stopPropagation();
              try { e.stopImmediatePropagation(); } catch (_) {}

              const links = [...ST.activeDropdown.querySelectorAll("a[href]")].filter(
                (a) => a.offsetParent !== null // solo elementi visibili
              );
              if (!links.length) return;

              const currentIndex = links.indexOf(document.activeElement);
              let nextIndex;

              if (e.key === "ArrowDown") { 
                nextIndex = currentIndex === links.length - 1 ? 0 : currentIndex + 1;
              } else {
                nextIndex = currentIndex <= 0 ? links.length - 1 : currentIndex - 1;
              }

              links[nextIndex].focus({ preventScroll: true });
              return;
            }

            // TAB: esce dal submenu e lascia il comportamento nativo
            if (e.key === "Tab") {
              exitSubmenu(root);
              return;
            }

          }
        }

        // ── 3. ESC DENTRO DROPDOWN => torna al top-level link ───────────────
        if (e.key === "Escape") {
          const dd = e.target.closest(DROPDOWN_SEL);
          if (!dd) return;

          e.preventDefault();
          e.stopPropagation();
          try { e.stopImmediatePropagation(); } catch (_) {}

          const item = dd.closest(ITEM_SEL);
          const tl = item?.querySelector(TOPLINK_SEL);

          exitSubmenu(root);
          if (tl) tl.focus({ preventScroll: true });
        }
      },
      true
    );

    // Se il focus esce dal menu => reset (così non restano link sbloccati)
    document.addEventListener(
      "focusin",
      (e) => {
        if (!isDesktop()) return;
        if (!root.contains(e.target)) exitSubmenu(root);
      },
      true
    );

    // Se il tema rimonta roba o "riapre", noi manteniamo TAB-lock sempre
    const mo = new MutationObserver(() => {
      if (!isDesktop()) return;
      applyTabLock(root);
    });
    mo.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-expanded"],
    });

    window.__KB_MENU_READY__ = true;
    ST.readyAt = new Date().toISOString();
    //console.error("KB MENU READY (desktop)", { boots: ST.boots, readyAt: ST.readyAt });

    return true;
  }

  // ====== BOOT + RETRY ======
  if (!attach()) {
    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      if (attach() || tries > 40) clearInterval(iv);
    }, 250);
  }
})();

